// import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
// import { Link } from "react-router-dom";

// const sections = [
//   {
//     id: "general",
//     title: "General",
//     content: [
//       '1.1 Your access, or otherwise any usage of the Website means you agree to these Terms read with all the policies that may be available on the Website (collectively, the "Agreement").',
//     ],
//   },
//   {
//     id: "registration",
//     title: "Registration of Your Account",
//     content: [
//       '2.1 In order to access or use the Website you must set up an account by providing information about yourself as prompted on the sign-up page of the Website which may include your name, gender, mobile number and such other details relevant for placing orders through your account. Your login details will be created basis the information provided by you, which you can use to access your MediSYS account at any time. Your details shared by you at the time of registration will be stored and referred to as "Account Information".',
//       "2.2 You are solely authorized to operate the account created by you. Consequently, it is your responsibility to maintain the confidentiality of your Account Information. You shall remain solely responsible for all the actions by you on your account.",
//     ],
//   },
//   {
//     id: "communication",
//     title: "Communication and Unsubscription",
//     content: [
//       "3.1 You understand that once you have shared your Account Information and successfully registered on the Website, you may receive SMS or email notifications from MediSYS relating to your registration and transactions on the Website.",
//       "3.2 You consent to receive communications, notifications and commercial messages regarding any transaction / marketing / promotional activities that are related to your transaction on the website or the Products and Services that maybe available on the Website from time to time.",
//       "3.4 You can unsubscribe/opt-out from receiving marketing/promotional communications, newsletters and other notifications from the Company at any time by following the instructions set out in such communications.",
//     ],
//   },
//   {
//     id: "warranties",
//     title: "User Warranties and Restrictions",
//     content: [
//       "4.1 You represent and warrant that: (a) your use of the Website will not violate any applicable law or regulation; (b) all information that is submitted to the Company in connection with the Website is true, accurate and lawful.",
//     ],
//   },
//   {
//     id: "access",
//     title: "Access Outside the Republic of India",
//     content: [
//       "5.1 The Company makes no representation that the content on the Website is appropriate to be used or accessed outside the Republic of India. Any user who uses or access the Website from outside the Republic of India, do so at their own risk and are responsible for compliance with the laws of such jurisdiction.",
//     ],
//   },
//   {
//     id: "disclaimer",
//     title: "Disclaimer",
//     content: [
//       "6.1 The Company is solely responsible for providing you with an e-commerce website to purchase Product or avail third party services, if you deem fit.",
//       "6.2 It is hereby clarified that the manufacturers themselves are responsible for all compliances relating to the manufacturing of the Products including any labelling, mandatory declaration requirements, etc. under the applicable law.",
//       "6.4 You understand that the Website may provide third-party services to help you locate and make appointments for consultation with doctor/registered medical practitioners and/or diagnostics service centres. Please note that this service is provided by third-party, and the Website does not guarantee nor make any representation with respect to the correctness, completeness or accuracy of such services.",
//       "6.5 All communication between you and the third-party service provider is a separate transaction between you and such third-parties. Any liability or claim arising out of such third-party services availed by you shall be between you and such third party.",
//       '6.6 The products and the third-party services are provided to you on an "as is" basis. We do not make any representations or warranties on behalf of the products and third-party services.',
//     ],
//   },
//   {
//     id: "prescription",
//     title: "Prescription Medication Policy",
//     content: [
//       '7.1 The Website allows you to purchase the Products (prescription medicine) against a valid medical prescription issued by a medical expert/doctor to be provided to a registered pharmacist for the purpose of dispensing such medicine ("Prescription Drugs"), offered for sale on the Website. In order to purchase Prescription Drugs from the Website, you are required to upload a scanned copy of the valid prescription on the Website or email the same to the Company. The order would not be processed by the Company until it receives a copy of a valid prescription. The Company will verify the prescription forwarded by you and in case we observe any discrepancy in the prescription uploaded by you, we will cancel the order immediately.',
//     ],
//   },
//   {
//     id: "content",
//     title: "Content on the Website",
//     content: [
//       '8.1 All information, content, material, text, graphics, images, logos, button icons, software code, interface, design and the collection, arrangement and assembly of the content on the Website are the property of the Company or its affiliates ("Company Content"), and are protected under copyright, trademark and other applicable laws.',
//       "8.2 The Company may display on the Website any third-party logos, trade names, trademarks of other brands, as per the license granted to the Company by such brands.",
//       "8.3 No information, content or material from the Website may be copied, reproduced, republished, duplicated, copied, sold, resold, uploaded, posted, transmitted, distributed or otherwise exploited in any way without Company's express written permission.",
//     ],
//   },
//   {
//     id: "license",
//     title: "License and Use of Your Content",
//     content: [
//       "9.1 Your use of the Website, the Services, and access to the Company Content is subject to a limited, revocable and non-exclusive license which is granted to you when you register on the Website. You will use the Website solely for identifying Products, carrying out purchases of Products and processing returns and refunds, for your personal use only and not for business purposes.",
//       "9.2 The license granted to you does not include a license for: (a) resale of Products or commercial use of the Website or the Company Content, (b) any collection and use of product listings, description, or prices, (c) any use of data mining, robots, or similar data gathering and extraction tools.",
//       "9.3 You grant to the Company a royalty-free, perpetual, irrevocable, non-exclusive right and license to adopt, publish, reproduce, disseminate, transmit, distribute, copy, use, create derivative works from, display worldwide, or act on any material posted by you on the Website without additional approval or consideration.",
//     ],
//   },
//   {
//     id: "indemnification",
//     title: "Indemnification and Limitation of Liability",
//     content: [
//       "10.1 You agree to indemnify, defend and hold us harmless our affiliates, officers, directors, employees, consultants, licensors, agents, and representatives from and against any and all third-party claims, losses, liabilities, damages, and/or costs (including reasonable attorney fees and costs) arising from your access to or use of the Website, violation of these Terms, or infringement of any of our or any third-party intellectual property or other rights.",
//     ],
//   },
//   {
//     id: "contract",
//     title: "Our Contract of Sale",
//     content: [
//       "11.1 Listing and display of a Product by us on the Website is our invitation to you to make an offer for purchase of such Product. Likewise, the placement of an order on the Website by you is your offer to buy the Product(s) from us.",
//       '11.2 Once you have placed an order with us for purchase of a Product, you will receive an e-mail and/or mobile confirming receipt of your order and containing the details of your order (the "Order Confirmation"). The Order Confirmation is merely an acknowledgement that we have received your order and does not signify our acceptance of your offer.',
//       '11.3 We only accept your offer and conclude the contract of sale for a Products ordered by you, when the Product is shipped or dispatched to you and an e-mail confirmation and/or confirmation to your registered mobile number is sent stating that the Product has been shipped or dispatched (the "Shipment Confirmation").',
//       "11.4 If your order is dispatched in more than one package, you may receive separate Shipment Confirmations for each package, and each Shipment Confirmation and corresponding dispatch will conclude a separate contract of sale between you and us for the Product(s) specified in that Shipment Confirmation.",
//     ],
//   },
// ];

// const TermsAndConditions = () => {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   const [activeSection, setActiveSection] = useState(null);

//   return (
//     <div className="min-h-screen bg-[#f8fafa] font-poppins mt-36 lg:mt-0">
//       <Helmet>
//         <title>Terms & Conditions | MediSYS Pharmacy</title>
//         <meta
//           name="description"
//           content="Read MediSYS Pharmacy Terms & Conditions before using our platform."
//         />
//         <meta
//           name="keywords"
//           content="pharmacy, medical stores, online pharmacy, online pharmacy India, online medical store hyderabad"
//         />
//         <meta name="robots" content="index, follow" />
//         <meta
//           property="og:title"
//           content="Terms & Conditions | MediSYS Pharmacy"
//         />
//         <meta
//           property="og:description"
//           content="Terms and conditions for using MediSYS Pharmacy platform."
//         />
//       </Helmet>

//       {/* ── Hero strip ── */}
//       <div className="bg-[#162c2a] px-5 sm:px-8 lg:px-14 py-10 relative overflow-hidden">
//         <div
//           className="absolute inset-0 opacity-[0.04] pointer-events-none"
//           style={{
//             backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`,
//             backgroundRepeat: "repeat",
//             backgroundSize: "40px 40px",
//           }}
//         />
//         <div className="relative">
//           <div className="flex items-center gap-3 mb-3">
//             <span className="w-6 h-[2px] bg-[#ff601e] rounded-full" />
//             <span className="text-[11px] font-semibold uppercase tracking-widest text-[#5fbdb3]">
//               Legal
//             </span>
//           </div>
//           <h1 className="font-bold text-[28px] sm:text-[36px] text-white leading-tight">
//             Terms & Conditions
//           </h1>
//           <p className="mt-2 text-[13px] text-white/50 max-w-[480px]">
//             Please read these terms carefully before using the MediSYS Pharmacy
//             platform and services.
//           </p>
//           <div className="flex items-center gap-2 mt-4">
//             <span className="text-[11px] text-white/35">Last updated:</span>
//             <span className="text-[11px] font-medium text-white/60">2024</span>
//           </div>
//         </div>
//       </div>

//       <div className="mx-auto px-4 sm:px-6 lg:px-8 py-10">
//         {/* ── Intro block ── */}
//         <div className="bg-white rounded-2xl border border-[#e2eaea] shadow-[0_2px_12px_rgba(22,44,42,0.07)] p-6 sm:p-8 mb-6">
//           <div className="flex items-start gap-3 mb-4">
//             <div className="w-8 h-8 rounded-lg bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center flex-shrink-0 mt-0.5">
//               <svg
//                 width="14"
//                 height="14"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="#1e4a46"
//                 strokeWidth="2.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <circle cx="12" cy="12" r="10" />
//                 <line x1="12" y1="8" x2="12" y2="12" />
//                 <line x1="12" y1="16" x2="12.01" y2="16" />
//               </svg>
//             </div>
//             <h2 className="font-bold text-[17px] text-[#1e4a46]">
//               Welcome to MediSYS!
//             </h2>
//           </div>

//           <div className="flex flex-col gap-3 text-[13px] sm:text-[14px] text-[#374747] leading-[1.85] text-justify">
//             <p>
//               The website,{" "}
//               <span className="font-semibold text-[#1e4a46]">
//                 www.medisyspharmacy.com
//               </span>{" "}
//               ("MediSYS", "Website", "Pharmacy", "us" or "we") is managed and
//               operated by{" "}
//               <span className="font-semibold">Novagito AI Private Limited</span>
//               , a company incorporated under the laws of India, having its
//               registered office at Flat No 108, Bren Starlight, Cheemasandra
//               Gate, Virgonagar, Bengaluru - 560049.
//             </p>
//             <p>
//               The Website is a platform that facilitates online purchase by
//               consumers of pharmaceutical products like prescription drugs, over
//               the counter medicines etc., sold by MediSYS Pharmacy through its
//               licensed premises ("Products").
//             </p>
//             <p>
//               By using the Website, you expressly agree to be bound by the
//               Terms. If you do not agree with any of the Terms, please refrain
//               from using the Website.
//             </p>
//             <p>
//               Any individual who can enter into legally binding contracts as per
//               Indian Contract Act, 1872, i.e. individuals who are 18 years of
//               age or older, are of sound mind, and are not disqualified from
//               entering into contracts by any law, can use and access the
//               Website.
//             </p>
//           </div>

//           {/* Alert banner */}
//           <div className="mt-5 flex items-center gap-3 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl px-4 py-3">
//             <svg
//               width="16"
//               height="16"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="#ff601e"
//               strokeWidth="2.5"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               className="flex-shrink-0"
//             >
//               <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
//               <line x1="12" y1="9" x2="12" y2="13" />
//               <line x1="12" y1="17" x2="12.01" y2="17" />
//             </svg>
//             <p className="text-[12px] font-semibold text-[#ff601e]">
//               PLEASE READ THE TERMS CAREFULLY BEFORE USING THIS PLATFORM.
//             </p>
//           </div>
//         </div>

//         {/* ── Sections ── */}
//         <div className="flex flex-col gap-3">
//           {sections.map((section, idx) => {
//             const isOpen = activeSection === idx;
//             return (
//               <div
//                 key={section.id}
//                 className={`bg-white rounded-2xl border transition-all duration-200 overflow-hidden ${
//                   isOpen
//                     ? "border-[#5fbdb3] shadow-[0_4px_18px_rgba(22,44,42,0.1)]"
//                     : "border-[#e2eaea] shadow-[0_2px_8px_rgba(22,44,42,0.05)] hover:border-[#c5d5d4]"
//                 }`}
//               >
//                 <button
//                   className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
//                   onClick={() => setActiveSection(isOpen ? null : idx)}
//                 >
//                   <div className="flex items-center gap-3">
//                     <span
//                       className={`flex-shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-[11px] font-bold transition-colors duration-200 ${
//                         isOpen
//                           ? "bg-[#1e4a46] text-white"
//                           : "bg-[#eaf4f3] text-[#1e4a46]"
//                       }`}
//                     >
//                       {String(idx + 1).padStart(2, "0")}
//                     </span>
//                     <h3
//                       className={`text-[13px] sm:text-[14px] font-semibold transition-colors duration-200 ${
//                         isOpen ? "text-[#1e4a46]" : "text-[#374747]"
//                       }`}
//                     >
//                       {section.title}
//                     </h3>
//                   </div>
//                   <span
//                     className={`flex-shrink-0 w-7 h-7 rounded-xl flex items-center justify-center transition-all duration-200 ${
//                       isOpen
//                         ? "bg-[#1e4a46] text-white rotate-180"
//                         : "bg-[#f1f5f5] text-[#8faba9]"
//                     }`}
//                   >
//                     <svg
//                       width="12"
//                       height="12"
//                       viewBox="0 0 24 24"
//                       fill="none"
//                       stroke="currentColor"
//                       strokeWidth="2.5"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     >
//                       <path d="M6 9l6 6 6-6" />
//                     </svg>
//                   </span>
//                 </button>

//                 {isOpen && (
//                   <div className="px-5 pb-5 border-t border-[#f1f5f5] pt-4">
//                     <div className="pl-10 flex flex-col gap-3">
//                       {section.content.map((para, i) => (
//                         <div key={i} className="flex gap-3">
//                           <span className="flex-shrink-0 w-1 self-stretch bg-[#ff601e] rounded-full opacity-60" />
//                           <p className="text-[13px] sm:text-[14px] text-[#374747] leading-[1.85] text-justify">
//                             {para}
//                           </p>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>

//         {/* ── Footer note ── */}
//         <div className="mt-8 bg-[#162c2a] rounded-2xl p-6 relative overflow-hidden">
//           <div
//             className="absolute inset-0 opacity-[0.04] pointer-events-none"
//             style={{
//               backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`,
//               backgroundRepeat: "repeat",
//               backgroundSize: "40px 40px",
//             }}
//           />
//           <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
//             <div>
//               <p className="font-bold text-[15px] sm:text-[17px] text-white mb-1">
//                 Have questions about these terms?
//               </p>
//               <p className="text-[12px] text-white/50">
//                 Contact our support team and we'll help clarify.
//               </p>
//             </div>
//             <Link
//               to="/contact-us"
//               className="flex-shrink-0 flex items-center gap-2 bg-[#ff601e] hover:bg-[#e55519] text-white font-semibold text-[13px] px-5 h-10 rounded-xl transition-all duration-200 shadow-[0_3px_12px_rgba(255,96,30,0.35)] hover:-translate-y-0.5 whitespace-nowrap"
//             >
//               Contact Us
//               <svg
//                 width="13"
//                 height="13"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <path d="M5 12h14M12 5l7 7-7 7" />
//               </svg>
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TermsAndConditions;
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import LaunchLegalHeader from "../Components/common/LaunchLegalHeader";

const sections = [
  {
    id: "use-of-platform",
    title: "Use of the Platform",
    content: [
      "MediSYS Pharmacy provides a platform to browse, order, and receive medicines and healthcare products.",
      "You must be at least 18 years of age to use this Platform.",
      "You agree to use the Platform only for lawful purposes and in compliance with applicable laws.",
    ],
  },
  {
    id: "account-registration",
    title: "Account Registration",
    content: [
      "Users may be required to create an account to place orders.",
      "You agree to provide accurate and updated information.",
      "You are responsible for maintaining the confidentiality of your login credentials.",
      "All activities under your account will be deemed authorized by you.",
    ],
  },
  {
    id: "orders-payments",
    title: "Orders & Payments",
    content: [
      "All orders are subject to availability and acceptance.",
      "Prices are subject to change without prior notice.",
      "We reserve the right to cancel or refuse any order at our discretion, including suspected fraudulent transactions.",
      "Payments must be completed through approved payment methods.",
    ],
  },
  {
    id: "prescription-medicines",
    title: "Prescription Medicines",
    content: [
      "Certain medicines require a valid prescription.",
      "You agree to upload genuine and valid prescriptions where required.",
      "All prescriptions may be verified by a licensed pharmacist.",
      "Misuse or falsification of prescriptions may result in legal action.",
    ],
  },
  {
    id: "product-information",
    title: "Product Information",
    content: [
      "We strive to ensure accurate product information; however, we do not guarantee completeness or accuracy.",
      "Product images are for representation purposes only.",
    ],
  },
  {
    id: "intellectual-property",
    title: "Intellectual Property",
    content: [
      "All content on the Platform (logos, text, images, software) is owned or licensed by MediSYS Pharmacy.",
      "You may not copy, reproduce, or distribute any content without prior written permission.",
    ],
  },
  {
    id: "prohibited-activities",
    title: "Prohibited Activities",
    content: [
      "You agree not to:",
      "Use the Platform for unlawful purposes",
      "Attempt unauthorized access",
      "Upload harmful or malicious content",
      "Disrupt platform functionality",
    ],
  },
  {
    id: "limitation-of-liability",
    title: "Limitation of Liability",
    content: [
      'The Platform is provided "as is" without warranties of any kind.',
      "MediSYS Pharmacy shall not be liable for any direct, indirect, incidental, or consequential damages arising from use of the Platform.",
      "Use of the Platform is at your own risk.",
    ],
  },
  {
    id: "indemnity",
    title: "Indemnity",
    content: [
      "You agree to indemnify and hold harmless MediSYS Pharmacy, its employees, and affiliates from any claims or damages arising from your use of the Platform.",
    ],
  },
  {
    id: "termination",
    title: "Termination",
    content: [
      "We reserve the right to suspend or terminate your access at any time without notice if you violate these Terms.",
    ],
  },
  {
    id: "changes-to-terms",
    title: "Changes to Terms",
    content: [
      "We may update these Terms from time to time. Continued use of the Platform constitutes acceptance of the revised Terms.",
    ],
  },
  {
    id: "contact-information",
    title: "Contact Information",
    content: [
      "For any queries, please contact:",
      "MediSYS Pharmacy",
      "Email: medisys.customercare@gmail.com",
    ],
  },
];

const TermsAndConditions = ({ launchOnly = false }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [activeSection, setActiveSection] = useState(null);

  return (
    <div className={`min-h-screen bg-[#f8fafa] font-poppins ${launchOnly ? "" : "mt-36 lg:mt-0"}`}>
      {launchOnly && <LaunchLegalHeader />}
      <Helmet>
        <title>Terms & Conditions | MediSYS Pharmacy</title>
        <meta
          name="description"
          content="Read MediSYS Pharmacy Terms & Conditions before using our platform."
        />
        <meta
          name="keywords"
          content="pharmacy, medical stores, online pharmacy, online pharmacy India, online medical store hyderabad"
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Terms & Conditions | MediSYS Pharmacy"
        />
        <meta
          property="og:description"
          content="Terms and conditions for using MediSYS Pharmacy platform."
        />
      </Helmet>

      {/* ── Hero strip ── */}
      <div className={`bg-[#162c2a] py-10 relative overflow-hidden ${launchOnly ? "" : "px-5 sm:px-8 lg:px-14"}`}>
        <div
          className="absolute inset-0 opacity-[0.04] pointer-events-none"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`,
            backgroundRepeat: "repeat",
            backgroundSize: "40px 40px",
          }}
        />
        <div className={launchOnly ? "relative launch-wrap" : "relative"}>
          <div className="flex items-center gap-3 mb-3">
            <span className="w-6 h-[2px] bg-[#ff601e] rounded-full" />
            <span className="text-[11px] font-semibold uppercase tracking-widest text-[#5fbdb3]">
              Legal
            </span>
          </div>
          <h1 className="font-bold text-[28px] sm:text-[36px] text-white leading-tight">
            Terms & Conditions
          </h1>
          <p className="mt-2 text-[13px] text-white/50 max-w-[480px]">
            Please read these terms carefully before using the MediSYS Pharmacy
            platform and services.
          </p>
          <div className="flex items-center gap-2 mt-4">
            <span className="text-[11px] text-white/35">Last updated:</span>
            <span className="text-[11px] font-medium text-white/60">
              1st June, 2026
            </span>
          </div>
        </div>
      </div>

      <div className={launchOnly ? "launch-wrap py-10" : "mx-auto px-4 sm:px-6 lg:px-8 py-10"}>
        {/* ── Intro block ── */}
        <div className="bg-white rounded-2xl border border-[#e2eaea] shadow-[0_2px_12px_rgba(22,44,42,0.07)] p-6 sm:p-8 mb-6">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-8 h-8 rounded-lg bg-[#eaf4f3] border border-[#d4ecea] flex items-center justify-center flex-shrink-0 mt-0.5">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1e4a46"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>
            <h2 className="font-bold text-[17px] text-[#1e4a46]">
              Welcome to MediSYS Pharmacy!
            </h2>
          </div>

          <div className="flex flex-col gap-3 text-[13px] sm:text-[14px] text-[#374747] leading-[1.85] text-justify">
            <p>
              By accessing or using our website or mobile application
              ("Platform"), you agree to be bound by these Terms & Conditions.
              If you do not agree, please do not use the Platform.
            </p>
          </div>

          {/* Alert banner */}
          <div className="mt-5 flex items-center gap-3 bg-[#fff3ee] border border-[#ffd5c2] rounded-xl px-4 py-3">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ff601e"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="flex-shrink-0"
            >
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <p className="text-[12px] font-semibold text-[#ff601e]">
              PLEASE READ THE TERMS CAREFULLY BEFORE USING THIS PLATFORM.
            </p>
          </div>
        </div>

        {/* ── Sections ── */}
        <div className="flex flex-col gap-3">
          {sections.map((section, idx) => {
            const isOpen = activeSection === idx;
            return (
              <div
                key={section.id}
                className={`bg-white rounded-2xl border transition-all duration-200 overflow-hidden ${
                  isOpen
                    ? "border-[#5fbdb3] shadow-[0_4px_18px_rgba(22,44,42,0.1)]"
                    : "border-[#e2eaea] shadow-[0_2px_8px_rgba(22,44,42,0.05)] hover:border-[#c5d5d4]"
                }`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  onClick={() => setActiveSection(isOpen ? null : idx)}
                >
                  <div className="flex items-center gap-3">
                    <span
                      className={`flex-shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-[11px] font-bold transition-colors duration-200 ${
                        isOpen
                          ? "bg-[#1e4a46] text-white"
                          : "bg-[#eaf4f3] text-[#1e4a46]"
                      }`}
                    >
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <h3
                      className={`text-[13px] sm:text-[14px] font-semibold transition-colors duration-200 ${
                        isOpen ? "text-[#1e4a46]" : "text-[#374747]"
                      }`}
                    >
                      {section.title}
                    </h3>
                  </div>
                  <span
                    className={`flex-shrink-0 w-7 h-7 rounded-xl flex items-center justify-center transition-all duration-200 ${
                      isOpen
                        ? "bg-[#1e4a46] text-white rotate-180"
                        : "bg-[#f1f5f5] text-[#8faba9]"
                    }`}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </span>
                </button>

                {isOpen && (
                  <div className="px-5 pb-5 border-t border-[#f1f5f5] pt-4">
                    <div className="pl-10 flex flex-col gap-3">
                      {section.content.map((para, i) => (
                        <div key={i} className="flex gap-3">
                          <span className="flex-shrink-0 w-1 self-stretch bg-[#ff601e] rounded-full opacity-60" />
                          <p className="text-[13px] sm:text-[14px] text-[#374747] leading-[1.85] text-justify">
                            {para}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* ── Footer note ── */}
        <div className="mt-8 bg-[#162c2a] rounded-2xl p-6 relative overflow-hidden">
          <div
            className="absolute inset-0 opacity-[0.04] pointer-events-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='17' y='10' width='6' height='20' rx='2' fill='white'/%3E%3Crect x='10' y='17' width='20' height='6' rx='2' fill='white'/%3E%3C/svg%3E")`,
              backgroundRepeat: "repeat",
              backgroundSize: "40px 40px",
            }}
          />
          <div className="relative flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div>
              <p className="font-bold text-[15px] sm:text-[17px] text-white mb-1">
                Have questions about these terms?
              </p>
              <p className="text-[12px] text-white/50">
                Contact our support team and we'll help clarify.
              </p>
            </div>
            <a
              href={launchOnly ? "mailto:medisys.customercare@gmail.com" : "/contact-us"}
              className="flex-shrink-0 flex items-center gap-2 bg-[#ff601e] hover:bg-[#e55519] text-white font-semibold text-[13px] px-5 h-10 rounded-xl transition-all duration-200 shadow-[0_3px_12px_rgba(255,96,30,0.35)] hover:-translate-y-0.5 whitespace-nowrap"
            >
              Contact Us
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
